// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NsTabs__container{flex:1 1 auto;width:100%;font-family:\"proxima-nova\", \"OpenSans\", \"Pridi\", \"NotoSans\", \"NotoSansSC\", \"NotoSansHebrew\", \"NotoSansJapanese\", \"Hiragino Kaku Gothic Pro\", \"Yu Gothic Medium\", \"Yu Gothic\", Meiryo, \"source-han-sans-japanese\", \"source-han-sans-korean\", \"source-han-sans-simplified-c\", Helvetica, Arial, sans-serif}.NsTabs__tabsBar{position:relative;display:flex;flex:0 1 auto;border-radius:inherit;height:48px;max-width:100%;color:#272525;transition:.3s cubic-bezier(0.25, 0.8, 0.5, 1)}.NsTabs__sliderWrapper{position:absolute;bottom:0;margin:0 !important;transition:.3s cubic-bezier(0.25, 0.8, 0.5, 1);z-index:1}.NsTabs__slider{height:100%;width:100%;background-color:currentColor}", ""]);
// Exports
exports.locals = {
	"container": "NsTabs__container",
	"tabsBar": "NsTabs__tabsBar",
	"sliderWrapper": "NsTabs__sliderWrapper",
	"slider": "NsTabs__slider"
};
module.exports = exports;
